function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M8 12a2 2 0 11-4 0 2 2 0 014 0zM14 12a2 2 0 11-4 0 2 2 0 014 0zM18 14a2 2 0 100-4 2 2 0 000 4z",
  fill: "#333"
});

function SvgIconDots(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTggMTJDOCAxMy4xMDQ2IDcuMTA0NTcgMTQgNiAxNEM0Ljg5NTQzIDE0IDQgMTMuMTA0NiA0IDEyQzQgMTAuODk1NCA0Ljg5NTQzIDEwIDYgMTBDNy4xMDQ1NyAxMCA4IDEwLjg5NTQgOCAxMloiIGZpbGw9IiMzMzMzMzMiLz4KPHBhdGggZD0iTTE0IDEyQzE0IDEzLjEwNDYgMTMuMTA0NiAxNCAxMiAxNEMxMC44OTU0IDE0IDEwIDEzLjEwNDYgMTAgMTJDMTAgMTAuODk1NCAxMC44OTU0IDEwIDEyIDEwQzEzLjEwNDYgMTAgMTQgMTAuODk1NCAxNCAxMloiIGZpbGw9IiMzMzMzMzMiLz4KPHBhdGggZD0iTTE4IDE0QzE5LjEwNDYgMTQgMjAgMTMuMTA0NiAyMCAxMkMyMCAxMC44OTU0IDE5LjEwNDYgMTAgMTggMTBDMTYuODk1NCAxMCAxNiAxMC44OTU0IDE2IDEyQzE2IDEzLjEwNDYgMTYuODk1NCAxNCAxOCAxNFoiIGZpbGw9IiMzMzMzMzMiLz4KPC9zdmc+";
export { SvgIconDots as ReactComponent };